const MOBILE_WIDTH = 719;

export default {
  props: {
    picture: { type: String },
    section: { type: String },
    clickable: { type: Boolean },
    isAi: { type: Boolean },
    userReference: { type: String },
    name: { type: String },
    membershipType: { type: [Number, String] },
    hasQuotationMark: { type: Boolean, default: false },
    limitTextOneLine: { type: Boolean, default: false },
    showBadge: { type: Boolean, default: true },
    content: { type: String },
    hasTooltip: { type: Boolean, default: false },
    membershipClickable: { type: Boolean, default: false },
    provider: { type: Object, default: () => {} },
    mini: { type: Boolean, default: false },
    index: { type: String },
    extendedCard: { type: Boolean, default: false },
    altText: { type: String, default: 'Voice123 Membership Plans' }
  },

  data() {
    return {
      mobileWidth: MOBILE_WIDTH,
      windowWidth: window.innerWidth
    };
  },

  computed: {
    underMobileWidth() {
      return this.windowWidth <= this.mobileWidth;
    },

    hasContent() {
      return this.content || this.$slots.content !== undefined;
    },

    voiceType() {
      let words = this.provider['mainContent'] ? this.provider['mainContent'].split(',') : '';

      if (words.length === 1) {
        words = this.provider['mainContent'].split('.');
      }
      let ans = words[0] ? words[0] : ' ';
      let i = 1;

      while (i < words.length && (ans.length + words[i].length + 2) <= 30) {
        ans += ', ' + words[i];
        i++;
      }
      return ans.length > 30 ? ans.substring(0, 25) + '...' : ans;
    },

    providerRating() {
      const provider = this.provider;

      if (provider.stats.reviews_rating && provider.stats) {
        return Number(provider.stats.reviews_rating.toFixed(1));
      }
    },

    styleObject() {
      let background = 'url(/static/profile_pic.png)';

      if (this.picture && this.picture.includes('http')) {
        background = `url(${this.picture})`;
      }
      return {
        'background-image': background,
        width: 'inherit',
        height: 'inherit',
        display: 'block'
      };
    }
  },

  methods: {
    onCardClick() {
      if (this.clickable) {
        this.$emit('click', { id: this.userReference })
      }
    }
  }
};